/**
 * CSS Constants
 */
/** @hidden */
export const root = 'e-gantt';
export const ganttChartPane = 'e-gantt-chart-pane';
export const treeGridPane = 'e-gantt-tree-grid-pane';
export const splitter = 'e-gantt-splitter';
export const ganttChart = 'e-gantt-chart';
export const ganttSingleTimeline = 'e-gantt-single-timeline';
export const chartBodyContainer = 'e-chart-root-container';
export const toolbar = 'e-gantt-toolbar';
export const chartScrollElement = 'e-chart-scroll-container';
export const chartBodyContent = 'e-chart-rows-container';
export const scrollContent = 'e-content';
export const adaptive = 'e-device';
export const focusCell = 'e-grid';
// Timeline-Class
export const taskTable = 'e-task-table';
export const zeroSpacing = 'e-zero-spacing';
export const timelineHeaderContainer = 'e-timeline-header-container';
export const timelineHeaderTableContainer = 'e-timeline-header-table-container';
export const timelineHeaderTableBody = 'e-timeline-header-table-body';
export const timelineTopHeaderCell = 'e-timeline-top-header-cell';
export const timelineHeaderCellLabel = 'e-header-cell-label';
export const weekendHeaderCell = 'e-weekend-header-cell';
export const timelineSingleHeaderCell = 'e-timeline-single-header-cell';
export const timelineSingleHeaderOuterDiv = 'e-timeline-single-header-outer-div';
export const virtualTable = 'e-virtualtable';
export const virtualTrack = 'e-virtualtrack';
// Chart Rows-Class
export const leftLabelContainer = 'e-left-label-container';
export const leftLabelTempContainer = 'e-left-label-container e-left-label-temp-container';
export const leftLabelInnerDiv = 'e-left-label-inner-div';
export const rightLabelContainer = 'e-right-label-container';
export const rightLabelTempContainer = 'e-right-label-container e-right-label-temp-container';
export const rightLabelInnerDiv = 'e-right-label-inner-div';
export const taskBarMainContainer = 'e-taskbar-main-container';
export const parentTaskBarInnerDiv = 'e-gantt-parent-taskbar-inner-div';
export const parentProgressBarInnerDiv = 'e-gantt-parent-progressbar-inner-div';
export const taskLabel = 'e-task-label';
export const childTaskBarInnerDiv = 'e-gantt-child-taskbar-inner-div';
export const childProgressBarInnerDiv = 'e-gantt-child-progressbar-inner-div';
export const criticalChildTaskBarInnerDiv = 'e-gantt-child-critical-taskbar-inner-div';
export const criticalChildProgressBarInnerDiv = 'e-gantt-child-critical-progressbar-inner-div';
export const criticalMilestone = 'e-critical-milestone';
export const baselineBar = 'e-baseline-bar';
export const baselineMilestoneContainer = 'e-baseline-gantt-milestone-container';
export const baselineMilestoneDiv = 'e-baseline-gantt-milestone';
export const chartRowCell = 'e-chart-row-cell';
export const chartRow = 'e-chart-row';
export const rowExpand = 'e-row-expand';
export const rowCollapse = 'e-row-collapse';
export const collapseParent = 'e-collapse-parent';
export const collapseMultiTaskBar = 'e-gantt-multi-taskbar';
export const taskBarLeftResizer = 'e-taskbar-left-resizer';
export const taskBarRightResizer = 'e-taskbar-right-resizer';
export const childProgressResizer = 'e-child-progress-resizer';
export const progressBarHandler = 'e-progressbar-handler';
export const progressHandlerElement = 'e-progressbar-handler-element';
export const progressBarHandlerAfter = 'e-progressbar-handler-after';
export const icon = 'e-icon';
export const traceMilestone = 'e-gantt-milestone';
export const parentMilestone = 'e-gantt-parent-milestone';
export const traceChildTaskBar = 'e-gantt-child-taskbar';
export const traceChildProgressBar = 'e-gantt-child-progressbar';
export const manualParentMainContainer = 'e-manualparent-main-container';
export const manualParentTaskBar = 'e-gantt-manualparenttaskbar';
export const manualParentMilestone = 'e-gantt-manualparent-milestone';
export const manualChildTaskBar = 'e-gantt-child-manualtaskbar';
export const manualChildProgressBar = 'e-gantt-child-manualprogressbar';
export const manualParentRightResizer = 'e-gantt-manualparenttaskbar-right';
export const manualParentLeftResizer = 'e-gantt-manualparenttaskbar-left';
export const traceManualUnscheduledTask = 'e-gantt-unscheduled-manualtask';
export const traceParentTaskBar = 'e-gantt-parent-taskbar';
export const traceParentProgressBar = 'e-gantt-parent-progressbar';
export const traceUnscheduledTask = 'e-gantt-unscheduled-task';
export const criticalUnscheduledTask = 'e-gantt-critical-unscheduled-taskbar';
export const taskIndicatorDiv = 'e-indicator-span';
export const leftResizeGripper = 'e-left-resize-gripper';
export const rightResizeGripper = 'e-right-resize-gripper';
export const progressResizeGripper = 'e-progress-resize-gripper';
export const label = 'e-label';
export const templatePadding = 'e-template-padding';
//event Markers classes
export const eventMarkersContainer = 'e-event-markers-container';
export const eventMarkersChild = 'e-event-markers';
export const eventMarkersSpan = 'e-span-label';
//holiday classes
export const nonworkingContainer = 'e-nonworking-day-container';
export const holidayContainer = 'e-holiday-container';
export const holidayElement = 'e-holiday';
export const holidayLabel = 'e-span';
//weekend classes
export const weekendContainer = 'e-weekend-container';
export const weekend = 'e-weekend';
//Unscheduled Taskbar
export const unscheduledTaskbarLeft = 'e-gantt-unscheduled-taskbar-left';
export const unscheduledTaskbarRight = 'e-gantt-unscheduled-taskbar-right';
export const unscheduledTaskbar = 'e-gantt-unscheduled-taskbar';
export const unscheduledMilestoneTop = 'e-unscheduled-milestone-top';
export const unscheduledMilestoneBottom = 'e-unscheduled-milestone-bottom';
//Connector Line
export const dependencyViewContainer = 'e-gantt-dependency-view-container';
export const connectorLineContainer = 'e-connector-line-container';
export const connectorLine = 'e-line';
export const connectorLineSVG = 'e-connector-line';
export const criticalConnectorLineSVG = 'e-critical-line';
export const criticalConnectorArrowSVG = 'e-critical-line-arrow';
export const connectorLineArrow = 'e-connector-line-arrow';
export const criticalConnectorLine = 'e-criticalconnector-line';
export const criticalConnectorLineRightArrow = 'e-criticalconnector-line-right-arrow';
export const criticalConnectorLineLeftArrow = 'e-criticalconnector-line-left-arrow';
export const connectorLineRightArrow = 'e-connector-line-right-arrow';
export const connectorLineLeftArrow = 'e-connector-line-left-arrow';
export const connectorLineZIndex = 'e-connector-line-z-index';
export const connectorLineHover = 'e-connector-line-hover';
export const criticalConnectorLineHover = 'e-critical-connector-line-hover';
export const connectorLineHoverZIndex = 'e-connector-line-hover-z-index';
export const connectorLineRightArrowHover = 'e-connector-line-right-arrow-hover';
export const connectorLineLeftArrowHover = 'e-connector-line-left-arrow-hover';
export const criticalConnectorLineRightArrowHover = 'e-critical-connector-line-right-arrow-hover';
export const criticalConnectorLineLeftArrowHover = 'e-critical-connector-line-left-arrow-hover';
export const connectorTouchPoint = 'e-connectortouchpoint';
export const connectorPointLeft = 'e-connectorpoint-left';
export const connectorPointRight = 'e-connectorpoint-right';
export const connectorPointLeftHover = 'e-connectorpoint-left-hover';
export const connectorPointRightHover = 'e-connectorpoint-right-hover';
export const falseLine = 'e-gantt-false-line';
export const connectorTooltipTaskName = 'e-tooltiptaskname';
export const connectorTooltipFalse = 'e-predecessor-false';
export const connectorTooltipTrue = 'e-predecessor-true';
export const rightConnectorPointOuterDiv = 'e-right-connectorpoint-outer-div';
export const leftConnectorPointOuterDiv = 'e-left-connectorpoint-outer-div';
export const connectorPointAllowBlock = 'e-connectorpoint-allow-block';
export const ganttTooltip = 'e-gantt-tooltip';
// Context Menu
export const columnHeader = '.e-gridheader';
export const content = '.e-content';
export const editForm = '.e-gridform';
export const deleteIcon = 'e-delete';
export const saveIcon = 'e-save';
export const cancelIcon = 'e-cancel';
export const ascendingIcon = 'e-icon-ascending';
export const descendingIcon = 'e-icon-descending';
export const editIcon = 'e-edit';
export const indentIcon = 'e-indent';
export const outdentIcon = 'e-outdent';
export const addIcon = 'e-add';
export const criticalPathIcon = 'e-critical-path';
export const addAboveIcon = 'e-add-above';
export const addBelowIcon = 'e-add-below';
//Predecessor touch mode
export const activeParentTask = 'e-active-parent-task';
export const activeChildTask = 'e-active-child-task';
export const activeConnectedTask = 'e-active-connected-task';
export const touchMode = 'e-predecessor-touch-mode';
//Over allocation range container
export const rangeContainer = 'e-rangecontainer';
export const rangeChildContainer = 'e-rg-rangdiv';
export const rangeChildMiddleContainer = 'e-rg-middlerangdiv';
//Pop Up
export const constraintLabel = 'e-constraint-label';
